import { FunctionComponent, JSXElementConstructor, ReactElement, useCallback } from "react";
import { Page, PageConfiguration, MenuItem } from "@fyrstain/fhir-front-library";
import i18n from "i18next";
import UserService from "../../services/UserService";
import { toPublicUrl } from "../../services/PublicUrl";
import { useNavigate } from "react-router-dom";

const ApplicationPage: FunctionComponent<{
    titleKey?: string;
    loading?: boolean;
    children?: ReactElement<any, string | JSXElementConstructor<any>>;
    needsLogin: boolean;
}> = (props) => {
    const navigate = useNavigate();

    const handleLogin = useCallback((config: MenuItem) => {
        if (config.needsLogin && !UserService.isAuthenticated()) {
            UserService.doLogin();
            navigate("/login");
        }
    }, [navigate]);

    const handleLangChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(event.target.value);
    };

    const fullConfig: PageConfiguration = {
        language: i18n.t,
        navigationBarConfigs: {
            homeLink: toPublicUrl("/vue-ensemble"),
            logoLink: toPublicUrl("/assets/logo.png"),
            logoWidth: "3.5rem",
            alt: "CHRU Nancy",
            authentication: {
                handleLogin,
                token: UserService.getKC().token,
                doLogin: UserService.doLogin,
                doLogout: UserService.doLogout,
                isAuthenticated: () => UserService.isAuthenticated() || false,
                getUserName: () => UserService.getUsername()
            },
            menuItems: [
                {
                    title: i18n.t("navbar.items.overview"),
                    link: toPublicUrl("/vue-ensemble"),
                    needsLogin: true
                },
                {
                    title: i18n.t("navbar.items.accompaniment"),
                    link: toPublicUrl("/accompagnement"),
                    needsLogin: true
                },
                {
                    title: i18n.t("navbar.items.followUp"),
                    link: toPublicUrl("/suivi"),
                    needsLogin: true
                },
                {
                    title: i18n.t("navbar.items.calendar"),
                    link: toPublicUrl("/calendrier"),
                    needsLogin: true
                }
            ],
            dropDownItems: []
        },
        titleKey: props.titleKey,
        loading: props.loading,
        children: props.children,
        needsLogin: props.needsLogin,
        footerConfigs: {
            languages: {
                default: i18n.language,
                onChange: handleLangChange,
                options: [
                    { label: "English", value: "en" },
                    { label: "Français", value: "fr" }
                ]
            },
            logo: [
                {
                    src: "https://fyrstain.com/wp-content/uploads/2022/10/Logo_fyrstain_horyzontal.svg",
                    alt: "Fyrstain",
                    href: "/vue-ensemble"
                }
            ],
            items: [
                { label: i18n.t("footer.items.about"), href: toPublicUrl("/") },
                { label: i18n.t("footer.items.contact"), href: toPublicUrl("/") },
                { label: i18n.t("footer.items.problemtracking"), href: toPublicUrl("/") }
            ]
        }
    };

    return <Page {...fullConfig} />;
};

export default ApplicationPage;
